import { RRIBaseTableActionSettings } from '../interfaces/table/base-table-action-settings.interface';
import { RRITableAddActionSettings } from '../interfaces/table/table-add-action-settings.interface';
import { RRITableDeleteActionSettings } from '../interfaces/table/table-delete-action-settings.interface';
import { RRITableEditActionSettings } from '../interfaces/table/table-edit-action-settings.interface';
import { RRTableActionModel } from '../models/table/table-action.model';

export type RRTableAction<T> = RRTableActionModel<
  | RRIBaseTableActionSettings
  | RRITableAddActionSettings<T>
  | RRITableEditActionSettings<T>
  | RRITableDeleteActionSettings<T>
>;
